import React from 'react'
import LoginPhoneInput from './LoginPhoneInput'

interface ILoginPhoneInputWrapProps {
  value?: string
  onlyPhone?: boolean
  isRequired?: boolean
  onChange: (value: string) => void
  onEntered?: (value: string) => void
  style?: object
}

const LoginPhoneInputWrap: React.FC<ILoginPhoneInputWrapProps> = ({
  value,
  onlyPhone,
  isRequired,
  onChange,
  onEntered,
  style,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', ...style }}>
      <LoginPhoneInput
        value={value}
        onlyPhone={onlyPhone}
        isRequired={isRequired}
        onChange={onChange}
        onEntered={onEntered}
        style={style}
      />
    </div>
  )
}
export default LoginPhoneInputWrap
